import React from 'react';

import Card from '@/components/atoms/card';

export interface CardsWithHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  footerLeft: React.ReactNode;
  footerRight?: React.ReactNode;
  badge?: React.ReactNode;
}

export default function CardsWithHeader({
  icon,
  title,
  description,
  footerLeft,
  footerRight,
  badge,
}: CardsWithHeaderProps) {
  return (
    <Card
      classNames={{
        root: 'p-0 w-full sm:min-w-[262px] sm:max-w-[262px] flex flex-col relative text-left h-full',
      }}
    >
      <div className='bg-neutral-N99 flex flex-col items-start gap-6 p-6 '>
        {icon}
        {title}
      </div>
      <div className='flex h-full flex-col justify-between gap-9 p-6'>
        <div className='flex'>{description}</div>
        <div className='flex h-10 items-center justify-between'>
          {footerLeft}
          {footerRight}
        </div>
      </div>
      {badge}
    </Card>
  );
}
